import { Root } from './components/Root/Root.js';
import { Main } from './components/Main/Main.js';
import { Title } from './components/Title/Title.js';

const Layout = {
    Root,
    Main,
    Title,
};

export { Layout };
